import type { MonitorDefinition } from '../../domain/model/Monitor.types';
import { toSearchFilter } from './common.mapper';
import type * as api from './generated/api';

export const toMonitorDefinitions = (input: api.MonitorList): MonitorDefinition[] =>
    input.items.map(toMonitorDefinition);

const toMonitorDefinition = (input: api.Monitor): MonitorDefinition => ({
    id: input.id,
    description: input.description,
    searchFilter: toSearchFilter(input.search_filter),
});
